<template>
  <div class="m-list-wrap">
    <van-pull-refresh v-if="total > 0"
                      v-model="isLoading"
                      :immediate-check="false"
                      @refresh="onRefresh">
      <van-list v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了"
                @load="loadList">
        <div class="approval-con">
          <div class="office-item"
              v-for="item in list"
              :key="item.TeachingProjectID"
              style="width:100%"
              @click="enterBtn(item)">
            <div class="title">
              <div class="nowrap tit">{{item.TeachingProjectName}}</div>
            </div>
            <div class="nowrap theme">{{item.SchoolDistrictName}}-{{item.AcademicYearName}}-{{item.AcademicSessionName}}</div>
            <div class="type">截止时间：{{xy.moment(item.EndDate).format('YYYY-MM-DD HH:mm')}}</div>
            <div class="status"
                :style="{'color':item.TeachingProjectStatus===2?'#4196ff':'#666'}">
              {{item.ProjectStatusName}}
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  name: "EvaOfTeacher",
  components: {},
  data () {
    return {
      isLoading: false, //是否处于下拉刷新状态
      pageIndex: 1,
      pageSize: 15,
      isRefresh: false, // 是否加载中
      finished: false, // 加载是否完成
      list: [],
      total: 0,

      index: 1, //tab切换展示
      searchName: "", //搜索
      notRead: "",
      status: -1,
      pathSource: "messageList"

      // listLoading: false
    };
  },
  computed: {},
  created () {
    this.loadList();
  },
  mounted () { },
  methods: {
    onRefresh () {
      setTimeout(() => {
        this.list = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.loadList();
      }, 500);
    },

    // 获取列表
    async loadList () {
      this.xy.loading();
      let res = await this.xyapi.get ( this.$store.state.apiPath + "/api/StudentTeachingProject/GetPageByRole", {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        schoolDistrictID: 0,
        academicSessionID: 0,
        pageType: 1
      })
      this.xy.unloading();
      if (res.success) {
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.list = [...this.list, ..._list];
        this.pageIndex++;
        this.finished = this.list.length >= res.data.totalRecords ? true : false;
      } else {
        this.xy.msgError(res.msg)
      }
      // 加载状态结束
      this.isRefresh = false;
    },

    // 跳转到答题详情页
    enterBtn: function (vals) {
      this.$store.commit("evaluation/setTeachingProjectRow", vals);
      this.$router.push("/home/evaOfTeacherDetails");
    }
  }
};
</script>
<style lang="less" scoped>
.approval-con {
  padding: 20px 15px 0;
  .office-item {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
    margin-bottom: 16px;
    padding: 12px 30px 22px;
    .title {
      display: flex;
      justify-content: space-between;
      .tit {
        flex: 1;
        max-width: 60%;
        font-size: 30px;
        line-height: 64px;
        font-weight: bold;
        color: #333;
      }
    }
    .type {
      font-size: 24px;
      color: #999;
      width: fit-content;
      height: 36px;
      line-height: 36px;
      padding: 0 20px 0 11px;
      margin-bottom: 15px;
      background: rgba(249, 249, 249, 1);
      border-radius: 14px 0px 14px 0px;
    }
    .theme {
      font-size: 28px;
      margin: 8px 0 20px;
      color: #666;
    }
    .status.pass {
      color: #21a83e;
    }
  }
}
</style>
